<div class="container mt-5">
    <div class="grid">
        <div class="col-5">
            <div class="wrapper-block text-center wrapper-position p-5">
                <div class="result-title">
                    <h3 class="success">Your payment was successful</h3>
                    <p>Congratulations on joining!</p>
                </div>
                <!-- <div class="image-success-container text-center">
                    <mat-icon>check_circle_outline</mat-icon>
                </div> -->
                <div class="pb-4 pt-5">
                    <button mat-raised-button color="success" (click)="continue()">Continue</button>
                </div>
            </div>
        </div>
    </div>
</div>